<template>
  <div class="w-full min-h-screen flex justify-center bg-ilift-200">
    <div class="mt-24 p-6 w-full">
      <div class="p-4 rounded shadow overflow-hidden">
        <div class="">
          <button class="float-right" @click="logout()">Logout</button>
        </div>
        <h1 class="text-2xl font-semibold text-center text-gray-700">
          Select role
        </h1>
        <div class="flex mt-4 justify-center">
          <div
            class="card flex h-48 justify-center w-1/4 p-5 m-2 bg-white rounded shadow hover:bg-ilift-400 cursor-pointer"
            v-for="role in activatedRoles"
            @click="selectRole(role)"
            :key="role"
          >
            <p class="m-12 text-2xl font-semibold text-center text-gray-700">
              {{ roleName(role) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homepages, roles } from "@/config";

export default {
  data() {
    return {};
  },
  computed: {
    activatedRoles() {
      return this.$store.getters.isLoggedIn
        ? this.$store.state.auth.account.roles
        : [];
    }
  },
  mounted() {
    if (
      this.$store.getters.isLoggedIn &&
      this.$store.state.auth.account.roles.length == 1
    ) {
      this.selectRole(this.$store.state.auth.account.roles[0]);
    }
  },
  methods: {
    roleName(id) {
      return roles[id];
    },
    selectRole(role) {
      this.$store.dispatch("setRole", role);
      this.$router.push(homepages(role));
    },
    logout() {
      this.$store.dispatch("logout").finally(() => this.$router.push("/login"));
    }
  }
};
</script>
